import { css } from '@emotion/css'

const styles = {
  form: css({
    padding: '0 24px',
  }),
  label: css({
    fontWeight: 600,
    fontSize: 16,
    color: '#0b1236',
  }),
  formInput: css({
    width: '100%',
    marginBottom: '16px',
  }),
  formCheckboxLink: css({
    color: '#2f96f4',
    textDecoration: 'none',
  }),
  checkBox: css({
    display: 'flex',
    alignItems: 'flex-start',
    margin: '8px 0 16px',
  }),
  lastCheckbox: css({
    margin: '0',
  }),
  checkBoxLabel: css({
    marginTop: '-4px',
    display: 'block',
    color: '#5c5c5c',
  }),
  submitButton: css({
    color: '#fff',
    width: '100%',
    background: '#ba69c8',
    margin: '20px 0',
    '&:hover': {
      background: '#974ca4',
    },
  }),
  submissionErrorMessage: css({
    color: '#e25c59',
    fontWeight: '400',
    background: '#fceeee',
    border: '1px solid rgba(226,92,89,.3)',
    borderRadius: '3px',
    margin: '20px 0 0',
    padding: '10px',
    lineHeight: '1.4',
    width: '95%',
  }),
}

export default styles
